export default __webpack_public_path__ + "static/media/Totaljobs_logo.db3f7824.svg";